<script>
export default {
  props: {
    item: { type: Object, required: true },
  },
}
</script>

<template>
  <li class="border-b border-dotted mb-2 border-gray-400">
    <div class="flex flex-wrap">
      <div class="w-2/3">
        <div class="flex">
          <span class="mr-2">{{ `${item.qty}x` }}</span>
          <div>
            <span class="mr-2">{{ item.name }}</span>
            <BaseLink
              class="text-gold-500 underline cursor-pointer"
              :to="{ name: 'property-extras', query: $route.query }"
            >
              (edit)
            </BaseLink>
          </div>
        </div>
      </div>
      <div class="w-1/3 text-right">
        <span class="text-sm mr-1">{{ item.price.currency }}</span>
        <span>{{ item.price.net | currency }}</span>
      </div>
    </div>
  </li>
</template>
